import baseApi from 'services/api/baseApi';
import { getInvitationsEndpoints } from 'services/api/invitations/queries';
import { getSubscriptionEndpoints } from 'services/api/subscription/queries';
import { sharesEndpoints } from 'services/api/shares';
import { getMobileSettingsEndpoints } from 'services/api/mobile-settings/queries';
import { getUserInfoEndpoints } from 'services/api/user-info/queries';
import { getUserSettingsEndpoints } from 'services/api/user-settings/queries';

export const api = baseApi.injectEndpoints({
  endpoints: builder => ({
    ...getMobileSettingsEndpoints(builder),
    ...getUserInfoEndpoints(builder),
    ...getUserSettingsEndpoints(builder),
    ...getInvitationsEndpoints(builder),
    ...getSubscriptionEndpoints(builder),
    ...sharesEndpoints(builder),
  }),
});

export * from './axiosInstance';
